import { UnitShorthand } from 'types/unit-shorthand'
import { Unit } from '@prisma/client'

export const toUnitShorthand = (unit: Unit): UnitShorthand =>
  unit === Unit.INCHES ? 'in' : 'mm'
